import React from "react";

import DeliverySlice from "../../components/slices/delivery/DeliverySlice";
const Delivery = ({ slice }) => {
  return <DeliverySlice slice={slice} />;
};

export default Delivery;
